













import { Component, Prop, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import { ClientPolicyDto } from '@core/pages/CommissionModule/api'
import { FormStructure } from '@master/model/structure/FormStructure'
import { options } from '@core/model/UIOptions'

/**
 * In the future, can combine this section with employee benefit's detail section
 * but I just create for the sake of time
 */
@Component({
  components: {
    AppForm
  }
})
export default class RiderDetailSection extends Vue {
  @Prop({ default: {} }) policyInView: ClientPolicyDto
  @Prop({ default: {} }) policy: ClientPolicyDto
  @Prop({ default: () => [] }) productOptions: options[]

  get isDisabled () {
    // Remove anything related to store
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get isAutoCreated () {
    return this.policyInView?.creationType === 'auto'
  }

  /* eslint-disable @typescript-eslint/camelcase */
  get subPolicyStructure (): FormStructure<ClientPolicyDto> {
    return [
      {
        label: 'Rider Name',
        key: 'productOid',
        options: this.productOptions,
        disabled: this.isDisabled || this.isAutoCreated
      },
      {
        label: 'Benefit Amount ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.policyInView.productMetadata?.sumAssured,
          set: (val) => {
            this.policyInView.productMetadata.sumAssured = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Prem ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.policyInView.productMetadata?.premiumAmount,
          set: (val) => {
            this.policyInView.productMetadata.premiumAmount = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'NCP ($)',
        type: 'currency',
        precision: 2,
        model: {
          get: () => this.policyInView.productMetadata?.ncp,
          set: (val) => {
            this.policyInView.productMetadata.ncp = val
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Effective Date',
        type: 'date',
        key: 'startDate',
        disabled: this.isDisabled
      },
      {
        label: 'Expiry Date',
        type: 'date',
        key: 'endDate',
        disabled: this.isDisabled
      },
      {
        label: 'Duration',
        model: {
          get: () => this.policyInView.productMetadata?.duration,
          set: (val) => {
            this.policyInView.productMetadata.duration = val
          }
        },
        disabled: this.isDisabled
      }
    ]
  }
}
